import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    // When a new SW takes control (updated SW activated), reload the page
    // so it fetches fresh assets under the new SW.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (navigator.serviceWorker.controller) {
        window.location.reload();
      }
    });

    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered:', registration.scope);
        })
        .catch((error) => {
          console.log('SW registration failed:', error);
        });
    });
  } else {
    // DEV: unregister any stale SW so it can't serve cached Vite dev files.
    // Also auto-reload once if there was an active SW controlling this page —
    // the unregistration only takes full effect after a reload.
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      if (registrations.length > 0) {
        Promise.all(registrations.map((r) => r.unregister())).then(() => {
          // Reload once so this page is no longer under SW control
          window.location.reload();
        });
      }
    });
  }
}

createRoot(document.getElementById("root")!).render(<App />);
